import { useLocation } from "react-router-dom";
import type { Location } from "react-router-dom";

/**
 * Hook sécurisé pour useLocation() qui fonctionne même sans Router
 * Utilisé dans les composants partagés qui peuvent être utilisés dans différentes contexts
 */
export function useSafeLocation(): Location {
  try {
    return useLocation();
  } catch (error) {
    // On n'est pas dans un Router, on retourne un objet Location par défaut
    return {
      pathname: "/",
      search: "",
      hash: "",
      state: null,
      key: "",
    };
  }
}
